// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientMedicalDeviceOrderingList = createAction(
  'SET_PATIENT_MEDICAL_DEVICE_ORDERING_LIST'
)
export const setPatientMedicalDeviceOrderingEditOrder = createAction(
  'SET_PATIENT_MEDICAL_DEVICE_ORDERING_EDIT_ORDER'
)

export const setPatientMedicalDeviceOrderingTypeList = createAction(
  'SET_PATIENT_MEDICAL_DEVICE_ORDERING_TYPE_LIST'
)

export const resetPatientMedicalDeviceOrdering = createAction(
  'RESET_PATIENT_MEDICAL_DEVICE_ORDERING'
)
